import createAction from '../actionCreator';

const action = createAction('lab');

export const LOAD_LAB = action('LOAD_LAB');
export const LOAD_CATALOG = action('LOAD_CATALOG');
export const LOAD_PRODUCTS = action('LOAD_PRODUCTS');